// extracted by mini-css-extract-plugin
module.exports = {"formTitle":"formTitle_formTitle__1e10l"};